import { CategoryMM } from "./CategoryMM";

const rootCategory = new CategoryMM({
  id: 0,
  title: 'Все категории',
  icon: {
    link: '',
  },
})

export { rootCategory }